import { useEffect, useState } from "react";
import { Boundary } from "./Boundary";
import { BoundaryContext } from "./BoundaryContext";
import { toBoundary } from "./BoundaryJsonConverters";
import { Coordinate } from "ol/coordinate";

export interface BoundaryProviderProps {
  children: React.ReactNode;
}

export const BoundaryProvider = ({ children }: BoundaryProviderProps) => {
  const baseUrl = process.env.REACT_APP_TILE_URL;
  const [measurementMode, setMeasurementMode] = useState<"km" | "mi">("mi");
  const [showLabels, setShowLabels] = useState(true);
  const [boundaries, setBoundaries] = useState<Boundary[]>([]);
  const [selectedBoundary, setSelectedBoundary] = useState<
    Boundary | undefined
  >(undefined);

  const [overlayCoordinate, setOverlayCoordinate] = useState<
    Coordinate | undefined
  >(undefined);

  useEffect(() => {
    if (!baseUrl) return;

    let cancelled = false;

    (async () => {
      try {
        const response = await fetch(`${baseUrl}/data/config/boundaries.json`);

        if (!response.ok) {
          throw new Error(`Failed to load boundaries: ${response.status}`);
        }

        const raw = await response.json();

        const boundaries: Boundary[] = raw.map((b: any) => toBoundary(b));

        if (!cancelled) {
          setBoundaries(boundaries);
        }
      } catch (err) {
        console.error("Error loading boundaries:", err);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [baseUrl]);

  return (
    <BoundaryContext.Provider
      value={{
        boundaries,
        selectedBoundary: selectedBoundary,
        setSelectedBoundary: setSelectedBoundary,
        setOverlayCoordinate: setOverlayCoordinate,
        overlayCoordinate: overlayCoordinate,
        measurementMode: measurementMode,
        setMeasurementMode: setMeasurementMode,
        showLabels: showLabels,
        setShowLabels: setShowLabels,
      }}
    >
      {children}
    </BoundaryContext.Provider>
  );
};
